import { Link } from "react-router-dom";
import { useGetServices } from "../hooks/services/useGetServices";
import { useTranslation } from "react-i18next";
import { useGetSettings } from "../hooks/useGetSettings";

export default function Footer() {
  const { services } = useGetServices();
  const { settings } = useGetSettings();
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="container">
        <div className="row gy-5">
          {/* Logo and About */}
          <div className="col-lg-5 col-md-12">
            <div className="logo">
              <Link to="/">
                <img src="/images/benaa-logo.png" loading="lazy" alt="BENA’A AlMKANIA" />
              </Link>
              <p className="description">
                {t("footerAbout") || "بناء الأمكانيات شريك تقني يحوّل الأفكار إلى منتجات رقمية عملية وقابلة للنمو."}
              </p>
            </div>
          </div>

          {/* Quick Links / Services */}
          <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="col_info">
              <h3>{t("services")}</h3>
              <ul>
                {services?.slice(0, 5).map((service) => (
                  <li key={service.id}>
                    <Link to={`/services/${service.id}`}>
                      {service.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-lg-4 col-md-6 col-sm-6">
            <div className="col_info">
              <h3>{t("contact")}</h3>
              <ul className="contact_list">
                {settings?.address && (
                  <li>
                    <i className="fa-light fa-location-dot"></i>
                    <span>{settings.address}</span>
                  </li>
                )}
                {settings?.phone && (
                  <li>
                    <i className="fa-light fa-phone"></i>
                    <a href={`tel:${settings.phone}`}>{settings.phone}</a>
                  </li>
                )}
                {settings?.email && (
                  <li>
                    <i className="fa-light fa-envelope"></i>
                    <a href={`mailto:${settings.email}`}>{settings.email}</a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="copy_rights">
          <p>
            &copy; {new Date().getFullYear()} {t("allRightsReserved")}{" "}
            {t("forWabelNajd")}
          </p>

          <div className="social_media">
            {[
              { key: "facebook", icon: "fa-facebook-f" },
              { key: "insta", icon: "fa-instagram" },
              { key: "linkedin", icon: "fa-linkedin-in" },
              { key: "twitter", icon: "fa-x-twitter" },
            ].map((social) => {
              const url = settings?.[social.key];
              if (!url) return null;
              return (
                <a
                  key={social.key}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.key}
                >
                  <i className={`fa-brands ${social.icon}`}></i>
                </a>
              );
            })}
          </div>
        </div>

        <div className="establishment_details" aria-label={t("establishmentDetails")}>
          <strong>{t("legalBusinessName")}</strong>
          <span>
            <i className="fa-light fa-building" aria-hidden="true" />
            {t("establishmentNumber")}: <bdi>7002875123</bdi>
          </span>
          <span>
            <i className="fa-light fa-file-certificate" aria-hidden="true" />
            {t("commercialRegistration")}: <bdi>101024847</bdi>
          </span>
          <span>
            <i className="fa-light fa-location-dot" aria-hidden="true" />
            {t("officeAddress")}: {t("officeAddressValue")}
          </span>
          <a href="tel:0542031982">
            <i className="fa-light fa-phone" aria-hidden="true" />
            {t("phoneNumber")}: <bdi>0542031982</bdi>
          </a>
        </div>
      </div>
    </footer>
  );
}
